import { ApiClientInterface } from './clients';
import { RegisteredUser } from './models';
import { LenderInput } from './types';

export class RegistrationManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public registerLender(lenderInput: LenderInput): Promise<RegisteredUser> {
    return this.apiClient.post('/lender', lenderInput);
  }
}
